import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargeDriverDetailScreen from './screens/ChargeDriverDetailScreen';
import ChargeDriverListScreen from './screens/ChargeDriverListScreen';

ChargeDriver.propTypes = {};

function ChargeDriver(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<ChargeDriverListScreen />} />
          <Route path=":chargeDriverId" element={<ChargeDriverDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeDriver;
